package com.bikompanion.ui.composables

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window

@Composable
internal actual fun rememberDirectionsLauncher(
    latitude: Double,
    longitude: Double,
    label: String,
): () -> Unit {
    val url = webDirectionsUrl(latitude, longitude)
    return remember(url) { { window.open(url, "_blank") } }
}
